module.exports = __webpack_public_path__ + "media/screenshots/application_id-e594edcd.png";